import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const WhatweDo = () => {

  const [data, setData] = useState("");
  let navigate = useNavigate();

  useEffect(() => {
    const url = "https://sbvmapi.uniservedata.in/api/content?nameType=Facelities";
    GetData(url);
  }, []);

  const GetData = async (url) => {
    const data = await fetch(url);
    const res = await data.json();
    setData(res.content_data);
  }

  const getImg = (url) => {
    const parts = url.split("\/");
    const newurl = "https://sbvmapi.uniservedata.in/image/" + parts[1];
    return newurl;
  }

  const routeChange = (id) => {
    let path = "Home/" + id;
    navigate(path);
  }




  return (

    <>

      <div className="news_section layout_padding "style={{"backgroundColor": "rgba(219, 176, 219, 0.20)"}}>
        <div className="container">

        <div className="row d-flex align-items-center justify-content-center vh-100">
  <div className="col-md-8 text-center">
    <div style={{ display: 'inline-block', textAlign: 'center' }}>
      <h1 className="news_taital" style={{ marginBottom: '0' }}>Our Speciality
      <hr
        style={{
          height: '3px',
          backgroundColor: 'currentColor',
          width: '78%',
          margin: '14px auto 17px',
          border: 'none',
        }}
      /></h1>
    </div>
  </div>
</div>



          <div className="row text-center  g-3 ">
            {data.length > 0 && data.map((datas) => <>

              <div class="card cardman col-lg-4 col-md-4">
                <div class="stat-card-what  p-4 hover-bounce">
                  <img class="card-img-top" src={getImg(datas.img)} alt="Card image cap" />
                  <div class="card-body">
                    <h3 className="card-title">{datas.heading}</h3>
                    <p className="card-text" dangerouslySetInnerHTML={{ __html: datas.textData }}></p>
                    <button className="buttoncust" onClick={() => routeChange(datas._id)}>Read More</button>
                  </div>
                </div>

              </div>

            </>)}
          </div>
        </div>
      </div>


      <div class="service-tag py-5 about_section">
        <div class="container">
          <div class="row text-center text-white">

            <div class="col-lg-3 col-md-6 mb-4">
              <div class="stat-card  bounce">
                <i class="fa fa-user mb-3 fa-3x"></i>
                <h2>Students</h2>
                <hr class="hr-white-bold"></hr>
                <h2>2236</h2>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 mb-4">
              <div class="stat-card  bounce">
                <i class="fa fa-users mb-3 fa-3x"></i>
                <h2>Teachers</h2>
                <hr class="hr-white-bold"></hr>
                <h2>90</h2>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 mb-4">
              <div class="stat-card  bounce">
                <i class="fa fa-trophy mb-3 fa-3x"></i>
                <h2>Winning Awards</h2>
                <hr class="hr-white-bold"></hr>
                <h2>1250</h2>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 mb-4">
              <div class="stat-card  bounce">
                <i class="fa fa-users mb-3 fa-3x"></i>
                <h2>Members</h2>
                <hr class="hr-white-bold"></hr>
                <h2>200</h2>
              </div>
            </div>

          </div>
        </div>
      </div>



    </>
  );
}
export default WhatweDo;